import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about-section">
      <h2>About KOIRO</h2>
      <p>
        <strong>KOIRO</strong>는 일본어로 ‘마음’을 뜻하는 <strong>KOKORO</strong>와
        ‘색’을 의미하는 <strong>IRO</strong>의 결합입니다. 이 이름에는 감정과 개성을
        온전히 담겠다는 의미가 녹아 있습니다.
      </p>
      <p>
        그런 KOIRO의 상징은 <strong>삼색 고양이(Calico Cat)</strong>. 흰색, 주황색,
        검정색이 조화를 이루는 이 고양이는 단순한 외형 이상의 의미를 지닙니다.
        유전적으로 대부분 암컷이며, 독립적이지만 애정 어린 존재로 알려져 있습니다.
      </p>
      <p>
        <strong>Calico</strong>는 종이 아닌 ‘색의 패턴’을 의미합니다. 이는 KOIRO가
        특정한 틀보다는 <span>다양성과 조화</span>를 중시한다는 철학과 닮아 있습니다.
      </p>
      <p>
        일본에서는 삼색 고양이를 행운의 상징으로 여깁니다. KOIRO도 나의 색과 마음이
        어우러져 삶에 긍정적인 변화를 만들어가는 여정을 담습니다.
      </p>
    </section>
  );
}

export default About;
